// extracted by mini-css-extract-plugin
export var cardBody = "wish-list-card-module--cardBody--7432b";
export var cardDescription = "wish-list-card-module--cardDescription--6ab2f";
export var cardTitle = "wish-list-card-module--cardTitle--46cf6";
export var listContent = "wish-list-card-module--listContent--2ae9b";
export var modalBody = "wish-list-card-module--modalBody--4863b";
export var modalDialog = "wish-list-card-module--modalDialog--f1355";
export var modalHeader = "wish-list-card-module--modalHeader--a919f";